// The backend stores/serialises timestamps as naive datetimes — no "Z" or
// UTC offset in the JSON (e.g. "2026-08-23T10:30:00"), but the underlying
// value is UTC. Without a timezone designator, JS parses that string as
// browser-local time instead of UTC, so every displayed time was silently
// off by the viewer's UTC offset (showing the raw UTC clock reading as if
// it were already IST). Force UTC parsing, then render explicitly in IST so
// the admin panel always shows Vandigo's own local time.
const HAS_TIMEZONE = /Z$|[+-]\d{2}:?\d{2}$/;

export function formatDate(dateStr) {
  if (!dateStr) return '—';
  const normalized = HAS_TIMEZONE.test(dateStr) ? dateStr : `${dateStr}Z`;
  return new Intl.DateTimeFormat('en-IN', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZone: 'Asia/Kolkata',
  }).format(new Date(normalized));
}

export function formatCurrency(amount) {
  if (amount === null || amount === undefined) return '—';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 2,
  }).format(amount);
}

export function getStatusColor(status) {
  const map = {
    active: 'success',
    completed: 'success',
    approved: 'success',
    verified: 'success',
    pending: 'warning',
    processing: 'warning',
    cancelled: 'danger',
    rejected: 'danger',
    failed: 'danger',
    inactive: 'default',
    pending_approval: 'warning',
  };
  return map[status?.toLowerCase()] ?? 'default';
}

export function truncate(str, maxLen = 30) {
  if (!str) return '—';
  return str.length > maxLen ? str.slice(0, maxLen) + '…' : str;
}

export function getErrorMessage(err, fallback = 'Something went wrong. Please try again.') {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  return fallback;
}
